import React, { useState } from 'react';

import { Container, Typography, Grid } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { ThemeProvider } from '@mui/material/styles';
import { ScopedCssBaseline } from '@mui/material';
import theme from '../../../theme';
import PaymentMethodBillingDetailsSection from './PaymentMethodBillingDetailsSection';
import PaymentMethodCardSection from './PaymentMethodCardSection';

const PaymentMethodNew = () => {
  const [showCardSection, setShowCardSection] = useState(false);
  const [billingDetails, setBillingDetails] = useState(null);

  const handleBillingDetailsSubmit = async (values) => {
    setShowCardSection(true);
    setBillingDetails(values);
  };

  const handleCardCancel = () => {
    setShowCardSection(false);
  };

  return (
    <ScopedCssBaseline>
      <ThemeProvider theme={theme}>
        <Container>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant='h4'
                component='h2'
                align='center'
                gutterBottom
              >
                New Payment Method
              </Typography>
              {showCardSection ? (
                <Elements
                  stripe={loadStripe(
                    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
                  )}
                >
                  <PaymentMethodCardSection
                    billingDetails={billingDetails}
                    onCancel={handleCardCancel}
                  />
                </Elements>
              ) : (
                <PaymentMethodBillingDetailsSection
                  onSubmit={handleBillingDetailsSubmit}
                  initialValues={billingDetails}
                />
              )}
            </Grid>
          </Grid>
        </Container>{' '}
      </ThemeProvider>
    </ScopedCssBaseline>
  );
};

export default PaymentMethodNew;
